<div class="ibox">
    <div class="ibox-content">
        <table>
            <tbody>
            <tr *ngFor="let delivery of deliveriesWithLoad">
                <td>
                    <small>{{delivery.delivery.deliveryNumber}}</small> <br> {{delivery.load.carrierName}}
                </td>
                <td class="text-right">
                    <app-bluechat-load-status class="status" [status]="delivery.load.status"></app-bluechat-load-status>
                </td>
            </tr>
            </tbody>
        </table>

    </div>
</div>
